import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { I18nProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";

import BridgeDatumLayout from "@/layouts/BridgeDatumLayout";
import EISGLayout from "@/layouts/EISGLayout";

// BridgeDatum pages
import BDHome from "@/pages/bridgedatum/Home";
import BDAbout from "@/pages/bridgedatum/About";
import BDSolutions from "@/pages/bridgedatum/Solutions";
import BDAdvisory from "@/pages/bridgedatum/Advisory";
import BDIntelligence from "@/pages/bridgedatum/Intelligence";
import BDSustainability from "@/pages/bridgedatum/Sustainability";
import BDSectors from "@/pages/bridgedatum/Sectors";
import BDInsights from "@/pages/bridgedatum/Insights";
import BDContact from "@/pages/bridgedatum/Contact";

// EISG pages
import EISGHome from "@/pages/eisg/Home";
import EISGAbout from "@/pages/eisg/About";
import EISGProgrammes from "@/pages/eisg/Programmes";
import EISGCohorts from "@/pages/eisg/Cohorts";
import EISGAdvisory from "@/pages/eisg/Advisory";
import EISGExperience from "@/pages/eisg/Experience";
import EISGInvestment from "@/pages/eisg/Investment";
import EISGRegistration from "@/pages/eisg/Registration";
import EISGContact from "@/pages/eisg/Contact";

const ScrollToTop = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  });
  return null;
};

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* BridgeDatum */}
            <Route element={<BridgeDatumLayout />}>
              <Route path="/" element={<BDHome />} />
              <Route path="/about" element={<BDAbout />} />
              <Route path="/solutions" element={<BDSolutions />} />
              <Route path="/advisory" element={<BDAdvisory />} />
              <Route path="/intelligence" element={<BDIntelligence />} />
              <Route path="/sustainability" element={<BDSustainability />} />
              <Route path="/sectors" element={<BDSectors />} />
              <Route path="/insights" element={<BDInsights />} />
              <Route path="/contact" element={<BDContact />} />
            </Route>

            {/* EISG */}
            <Route element={<EISGLayout />}>
              <Route path="/eisg" element={<EISGHome />} />
              <Route path="/eisg/about" element={<EISGAbout />} />
              <Route path="/eisg/programmes" element={<EISGProgrammes />} />
              <Route path="/eisg/cohorts" element={<EISGCohorts />} />
              <Route path="/eisg/advisory" element={<EISGAdvisory />} />
              <Route path="/eisg/experience" element={<EISGExperience />} />
              <Route path="/eisg/investment" element={<EISGInvestment />} />
              <Route path="/eisg/registration" element={<EISGRegistration />} />
              <Route path="/eisg/contact" element={<EISGContact />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </I18nProvider>
  );
}

export default App;
